import get from 'lodash/get';
import { getCurrentLanguage } from './getCurrentLanguage';
/* 
    input  : SitecoreContext
    return : pageTitle
*/
export const getPageTitle = sitecoreContext => {
  const pageTitle = sitecoreContext && get(sitecoreContext, 'route.fields.pageHeading.value', '') || get(sitecoreContext, 'route.fields.name.value', '');
  return pageTitle;
};
